import { ReactNode } from 'react';

import { IconAngleRight, IconClockOutline } from '@iwoca/icons';
import { Flex, Text } from '@iwoca/orion';
import { maintainStateKey } from '@iwRouter/LocationHelper';
import { Link, useLocation } from 'react-router-dom';

type TRequirementItemProps = {
    title: ReactNode;
    estimatedTime: ReactNode;
    href: string;
};

export const RequirementItem = ({
    title,
    estimatedTime,
    href
}: TRequirementItemProps) => {
    const { search } = useLocation();

    return (
        // ORION-113-GAP component: no clickable row, so the whole row is the
        // link, with the hover colour set by hand
        <Link
            to={maintainStateKey({ pathname: href, search })}
            className="block hover:bg-structure-95"
        >
            <Flex padding="container" gap="section" align="center">
                <Flex.Item grow>
                    <Flex gap="tight" align="center">
                        <Flex.Item grow>
                            <Text className="text-m font-med text-primary-40">
                                {title}
                            </Text>
                        </Flex.Item>
                        <IconAngleRight className="text-l text-primary-40" />
                    </Flex>
                </Flex.Item>
                <Flex.Item shrink={false}>
                    <Flex gap="tight" align="center">
                        <Text className="text-s font-reg text-structure-40">
                            {estimatedTime}
                        </Text>
                        <IconClockOutline className="text-s text-structure-40" />
                    </Flex>
                </Flex.Item>
            </Flex>
        </Link>
    );
};
